export function getGridLocalization (localize) {
  return {
    grid: {
      pagerItemsPerPage: localize('Common.GridPagerItemsPerPage'),
      pagerInfo: localize('Common.GridPagerInfo'),
      pagerFirstPage: localize('Common.GridPagerFirstPage'),
      pagerPreviousPage: localize('Common.GridPagerPreviousPage'),
      pagerNextPage: localize('Common.GridPagerNextPage'),
      pagerLastPage: localize('Common.GridPagerLastPage'),
      pagerPage: localize('Common.GridPagerPage'),
      pagerOf: localize('Common.GridPagerOf'),
      filterClearButton: localize('Common.GridFilterClearButton'),
      filterEqOperator: localize('Common.GridFilterEqOperator'),
      filterNotEqOperator: localize('Common.GridFilterNotEqOperator'),
      filterIsNullOperator: localize('Common.GridFilterIsNullOperator'),
      filterIsNotNullOperator: localize('Common.GridFilterIsNotNullOperator'),
      filterIsEmptyOperator: localize('Common.GridFilterIsEmptyOperator'),
      filterIsNotEmptyOperator: localize('Common.GridFilterIsNotEmptyOperator'),
      filterStartsWithOperator: localize('Common.GridFilterStartsWithOperator'),
      filterContainsOperator: localize('Common.GridFilterContainsOperator'),
      filterNotContainsOperator: localize('Common.GridFilterNotContainsOperator'),
      filterEndsWithOperator: localize('Common.GridFilterEndsWithOperator'),
      filterGteOperator: localize('Common.GridFilterGteOperator'),
      filterGtOperator: localize('Common.GridFilterGtOperator'),
      filterLteOperator: localize('Common.GridFilterLteOperator'),
      filterLtOperator: localize('Common.GridFilterLtOperator'),
      filterIsTrue: localize('Common.GridFilterIsTrue'),
      filterIsFalse: localize('Common.GridFilterIsFalse'),
      filterBooleanAll: localize('Common.GridFilterBooleanAll'),
      filterAfterOrEqualOperator: localize('Common.GridFilterAfterOrEqualOperator'),
      filterAfterOperator: localize('Common.GridFilterAfterOperator'),
      filterBeforeOperator: localize('Common.GridFilterBeforeOperator'),
      filterBeforeOrEqualOperator: localize('Common.GridFilterBeforeOrEqualOperator'),
      noRecords: localize('Common.GridNoRecords')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/BsrsGrid/BsrsGrid.Localization.js